import React from "react";
import { useSelector } from "react-redux";

import * as api from "@nens/threedi/openapi-client";

import { useLizardAggregateInStepsOfDay } from "../../hooks/useLizardAggregates";
import { getModelPolygon } from "../../state/simulation";
import { RainRaster } from "../../types/rasterRain";
import { getMaxValueForBarchartInMm } from "../../utils/rainRasterHelper";
import RainBarChart from "../RainBarChart";

export interface Props {
  existingLizardRasterRain: api.LizardRasterRain;
  rainRaster: RainRaster;
}

const ExistingLizardRasterRainBarChart: React.FC<Props> = ({
  existingLizardRasterRain,
  rainRaster,
}) => {
  const modelPolygon = useSelector(getModelPolygon);

  const stopDateTime = new Date(existingLizardRasterRain.startDatetime.getTime());
  stopDateTime.setSeconds(stopDateTime.getSeconds() + (existingLizardRasterRain.duration || 0));

  const barchartData = useLizardAggregateInStepsOfDay(
    existingLizardRasterRain.referenceUuid,
    modelPolygon || "",
    existingLizardRasterRain.startDatetime.toISOString(),
    stopDateTime.toISOString(),
    rainRaster.frequency,
    rainRaster.unit
  );

  if ((barchartData.results || []).length > 0) {
    return (
      <RainBarChart
        rainBarChartData={barchartData.results || []}
        chartTop={getMaxValueForBarchartInMm(barchartData.results || [], rainRaster)}
        showsData
      />
    );
  } else {
    return null;
  }
};

export default ExistingLizardRasterRainBarChart;
